var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#9FA4A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.105 19C25.7137 19 20.4595 23.884 19.9472 30.1111H18.6665C18.2614 30.1111 17.8962 30.3556 17.7419 30.7302C17.5876 31.1049 17.6746 31.5356 17.9622 31.821L20.202 34.0432C20.5918 34.43 21.2207 34.43 21.6106 34.0432L23.8504 31.821C24.138 31.5356 24.225 31.1049 24.0707 30.7302C23.9163 30.3556 23.5512 30.1111 23.146 30.1111H21.9556C22.4619 25.0022 26.8062 21 32.105 21C35.7977 21 39.0301 22.9446 40.8206 25.8571C41.1099 26.3275 41.7257 26.4745 42.1962 26.1852C42.6667 25.896 42.8136 25.2801 42.5244 24.8096C40.3826 21.3257 36.5163 19 32.105 19Z",
    fill: "#28475C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.788 29.9554C43.3985 29.5704 42.7717 29.5704 42.3821 29.9554L40.1338 32.1777C39.8454 32.4627 39.7577 32.8938 39.9118 33.2689C40.0659 33.644 40.4312 33.8889 40.8368 33.8889H42.0355C41.5272 38.9949 37.1677 43 31.8435 43C28.1335 43 24.8877 41.0537 23.0904 38.1415C22.8004 37.6715 22.1843 37.5256 21.7143 37.8157C21.2443 38.1057 21.0984 38.7218 21.3885 39.1918C23.5386 42.676 27.4186 45 31.8435 45C38.254 45 43.5298 40.119 44.044 33.8889H45.3334C45.7389 33.8889 46.1043 33.644 46.2584 33.2689C46.4125 32.8938 46.3248 32.4627 46.0363 32.1777L43.788 29.9554Z",
    fill: "#28475C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.80a9f961eb68c8470d1717b1aa87f373.svg";
export { ForwardRef as ReactComponent };